import axios from "./index";

class BankApi {
  static GetBanksList = (token) => {
    return axios.get(`${base}/banks/`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static GetBankById = (token, bankId) => {
    return axios.get(`${base}/banks/${bankId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static CreateBank = (token, data) => {
    return axios.post(`${base}/banks/`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static UpdateBank = (token, id, data) => {
    return axios.put(`${base}/banks/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static DeleteBank = (token, bankId) => {
    return axios.delete(`${base}/banks/${bankId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static GetBankTransactions = (token, bankId) => {
    return axios.get(`${base}/bank-transactions/${bankId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  static AffectBankToWarehouse = (token, warehouseId, bankIds) => {
    return axios.post(
      `${base}/warehouses/${warehouseId}/assign-banks/`,
      { bank_ids: bankIds },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };
}

let base = "banks";

export default BankApi;
